import { Component, OnInit } from '@angular/core';
import { GlCodeService } from './glcode.service';

@Component({
    selector: 'glCode',
    templateUrl: 'app/glcodeManagement/glcode.component.html',
    providers: [GlCodeService]
})
export class GlCodeComponent implements OnInit {

    constructor(private glCodeService: GlCodeService) { }

    glCode = {} as IGLCodeModel;
    glCodes: Array<IGLCodeModel>;
    editMode: boolean = false;
    departments: Array<IDepartmentModel>;

    ngOnInit() {
        this.loadGlCodes();
    }

    loadGlCodes() {
        this.glCodeService.getAllGlCodes().subscribe((response: Array<IGLCodeModel>) => {
            this.glCodes = response;
        });
    }

    addNewGLCode() {
        this.glCode = {} as IGLCodeModel;
        this.editMode = true;
    }

    cancel() {
        this.editMode = false;
    }

    editGlCode(glCode: IGLCodeModel) {
        this.glCode = glCode;
        this.editMode = true;
    }

    saveGLCode(glCode: IGLCodeModel) {
        if (glCode.id) {
            this.glCodeService.updateGlCode(glCode).subscribe((response: IGLCodeModel) => {
                if (response) {
                    this.editMode = false;
                    this.loadGlCodes();
                }
                    
            });
        } else {
            this.glCodeService.addGlCode(glCode).subscribe((response: IGLCodeModel) => {
                if (response) {
                    this.editMode = false;
                    this.loadGlCodes();
                }  
            });
        }
    }

}
